import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseApiService} from './services/base-api.service';
import {StartupApiService} from './services/startup-api.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    StartupApiService,
    // BaseApiService is abstract, not provided directly
  ],
})
export class CoreModule {}
